// extracted by mini-css-extract-plugin
export default {"wrapper":"FastGoldLink_wrapper","linkWrapper":"FastGoldLink_linkWrapper","link":"FastGoldLink_link","inlineLink":"FastGoldLink_inlineLink","withIcon":"FastGoldLink_withIcon"};